import React, { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { ApiStepper } from "./ApiStepper";
import { ApiService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { IWorkflow } from "../../workflow/dto/IWorkflow";
import { LoadingAnimation } from "../../../shared/components/Loading";
import { EmptyState } from "../../../shared/components/EmptyState";
import { Pagination } from "../../../shared/paginations/Paginations";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";
import { formatDate } from "../../../shared/functions/Functions";
import { Tooltip } from "react-tooltip";
import { BrandService } from "../../brand/service";
export const SecondStep = () => {
  const { id } = useParams();
  const [workflowName, setWorkflowName] = useState("WorkflowWithoutName");
  const [completeTab, setCompleteTab] = useState(false);
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
  const [tasksList, setTasksList] = useState<any[] | undefined>();
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { mappedExportFormatEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  const { accessRights } = useSelector((state: IAllStates) => state.auth);
  const isManager = currentUser?.roles?.includes("ROLE_MANAGER");
  const isAdmin = currentUser?.roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = currentUser?.roles?.includes("ROLE_COMPANY_ADMIN");
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const { exportView } = useSelector((state: IAllStates) => state.enums);
  const sendOptions = [
    { id: 1, title: t("global_v2.instant") },
    { id: 2, title: t("global_v2.automatic") },
  ];
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    clientProfileExport: id,
    status: "pending",
  });
  const [paginationCompleted, setPaginationCompleted] = useState({
    page: 1,
    perPage: 10,
    clientProfileExport: id,
    status: "sent",
  });
  const [pageCompleted, setPageCompleted] = useState(1);
  const [totalPagesCompleted, setTotalPagesCompleted] = useState(0);
  const [completedList, setCompletedList] = useState<any[] | undefined>();
  const [workflowList, setWorkflowList] = useState<any[] | undefined>();
  const handlePagesCompleted = (updatePage: number) => {
    setPaginationCompleted({ ...paginationCompleted, page: updatePage });
    setPageCompleted(updatePage);
  };
  const [selectedClient, setSelectedClient] = useState<any | undefined>();
  const handleShow = () => setShow(true);
  const deleteHandler = () => {
    selectedClient?.id &&
      ApiService.deleteTasksById(selectedClient?.id)
        .then((response) => {
          if (response === "") {
            SuccessToast(
              `${t("toasts.successfully_deleted")} ${selectedClient.name}`
            );
            setTriggerUpdate((prev) => !prev);
          }
        })
        .catch((error) => ErrorToast(error));
  };
  const handleSend = (taskId: number) => {
    ApiService.execute(taskId)
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_send")} ${response?.name}`);
      })
      .catch((error) => ErrorToast(error));
  };
  const handleDownloadDocument = (file: any, name: string) => {
    // files.forEach((file: any) => {
    const xhr = new XMLHttpRequest();
    const fileName = name;
    xhr.open("GET", file, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: "application/*" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? "";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 0);
      }
    };
    xhr.send();
    // });
  };
  const [formatChoice, setFormatChoice] = useState<string>("xlsx");
  const [viewChoice, setViewChoice] = useState<string>("html_source");
  const [sendChoice, setSendChoice] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  const handleClose = () => {
    setShow(false);
  };
  const formatChangeHandler = (e: any) => {
    setFormatChoice(e.target.value);
  };
  const viewChangeHandler = (e: any) => {
    setViewChoice(e.target.value);
  };
  const sendChangeHandler = (e: any) => {
    setSendChoice(Number(e.target.value));
  };

  const handleDownload = (file: any, name: string) => {
    const xhr = new XMLHttpRequest();
    const fileName = name;
    xhr.open("GET", file, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: "application/*" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? "";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 0);
      }
    };
    xhr.send();
  };
  const submitHandler = () => {
    ApiService.export(viewChoice, formatChoice, +id!)
      .then((res) => {
        const filePath = res?.path;
        const fileName = filePath?.split("/").pop();
        const fileExtension = fileName.split(".").pop();
        handleDownload(filePath, workflowName + "." + fileExtension);
        // const handleDownload = async () => {
        //   const jsonFileUrl = res?.path;
        //   const fileName = jsonFileUrl.split("/").pop();
        //   try {
        //     const response = await fetch(jsonFileUrl);
        //     if (!response.ok) throw new Error("Error during download");

        //     const blob = await response.blob();
        //     const link = document.createElement("a");
        //     link.href = URL.createObjectURL(blob);
        //     link.download = fileName;
        //     link.style.display = "none";
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //   } catch (error) {
        //     console.error("Error during download:", error);
        //   }
        // };
        // if (formatChoice === "json" || formatChoice === "xml") {
        //   handleDownload();
        // } else {
        //   window.open(res?.path);
        // }
      })
      .catch((err) => console.log(err));
  };
  const sendHandler = () => {
    ApiService.send(viewChoice, formatChoice, +id!)
      .then((res) => {
        setTriggerUpdate((prev) => !prev);
        SuccessToast(`${t("toasts.successfully_send")}`);
      })
      .catch((error) => ErrorToast(error));
  };

  // useEffect(() => {
  //   ApiService.getAllTasks(pagination)
  //     .then((response) => {
  //       const { data } = response;
  //       if (pagination?.page > 1 && pagination?.page > response?.totalPages) {
  //         setPage(response?.totalPages);
  //         setPagination({ ...pagination, page: response?.totalPages });
  //       }
  //       setTasksList(data);
  //       setTotalPages(Math.ceil(response?.count / response?.perPage));
  //     })
  //     .catch((error) => ErrorToast(error));
  // }, [pagination, triggerUpdate]);
  useEffect(() => {
    if (completeTab) {
      ApiService.getAllTasks({
        ...paginationCompleted,
        status: "sent",
      })
        .then((response) => {
          // setPagination(initialPagination);
          const { data } = response;
          setTotalPagesCompleted(
            Math.ceil(response?.count / response?.perPage)
          );
          setCompletedList(data);
          setPageCompleted(response?.page);
        })
        .catch((error) => ErrorToast(error));
    } else {
      ApiService.getAllTasks({
        ...pagination,
        status: "pending",
      })
        .then((response) => {
          const { data } = response;
          // !completeTab && setPaginationCompleted(initialPagination);
          if (pagination?.page > 1 && pagination?.page > response?.totalPages) {
            setPage(response?.totalPages);
            setPagination({ ...pagination, page: response?.totalPages });
          }
          setWorkflowList(data as any);
          setTotalPages(Math.ceil(response?.count / response?.perPage));
          // })
          // setTotalPages(Math.ceil(response?.count / response?.perPage));
          // setPage(response?.page);
          // setWorkflowList(data);
        })
        .catch((error) => ErrorToast(error));
    }
  }, [
    pagination,
    paginationCompleted,
    triggerUpdate,
    completeTab,
    // name,
    // completeName,
  ]);
  useEffect(() => {
    if (!!Number(id)) {
      ApiService.getById(+id!)
        .then((response) => {
          const { workflow } = response;
          setWorkflowName(workflow?.name ?? "WorkflowWithoutName");
        })
        .catch((error) => {
          ErrorToast(error);
        });
    }
  }, [id]);
  return (
    <>
      {" "}
      <Card>
        <Card.Body>
          <ApiStepper step={"EXPORT"} />
          <div className="row ">
            <div className="col-4">
              <h5>{t("workflow.format")}:</h5>
              {mappedExportFormatEnum?.map((format: string, idx: number) => (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="format"
                    id={`flexRadioDefault${idx}`}
                    value={format}
                    checked={formatChoice === format}
                    onChange={formatChangeHandler}
                  />
                  <label className="form-check-label" htmlFor="format">
                    {format.toUpperCase()}
                  </label>
                </div>
              ))}
            </div>
            <div className="col-4">
              <h5>{t("workflow.view")}:</h5>
              {exportView?.map((view: string, idx: number) => (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="view"
                    value={view}
                    checked={viewChoice === view}
                    id={`flexRadioDefault${idx}`}
                    onChange={viewChangeHandler}
                  />
                  <label className="form-check-label" htmlFor="view">
                    {`${t(`view.${view}`)}`}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="d-flex  d-flex align-items-center justify-content-end">
            <Button
              className="me-2"
              variant="info"
              type="button"
              onClick={() => navigate("/admin/api")}
            >
              {`${t("global.back")}`}
            </Button>
            <Button
              variant="secondary"
              className="me-2"
              onClick={sendHandler}
              // disabled={sendChoice === 0}
            >
              {t(`global_v2.queue`)}
            </Button>
            <Button
              className="me-2"
              variant="primary"
              onClick={submitHandler}
              aria-expanded="false"
            >
              {`${t("global.export")}`}
            </Button>{" "}
          </div>

          <Modal show={show} onHide={handleClose} size="sm" centered>
            <Modal.Body className="d-flex align-items-center flex-column">
              <h5>{t("modals.are_you_sure")}</h5>
              <p className="text-center text-muted">
                {t(`modals.are_you_sure_complete_workflow`)}
              </p>
            </Modal.Body>
            <Modal.Footer className="d-flex align-items-center justify-content-center">
              <Button variant="light" size="sm" onClick={handleClose}>
                {t(`modals.close`)}
              </Button>

              <Button variant="primary" size="sm" onClick={() => handleClose()}>
                {t(`global.complete`)}
              </Button>
            </Modal.Footer>
          </Modal>
        </Card.Body>
      </Card>
      <div className="card">
        <div className="card-header pb-0">
          <div className="d-flex justify-content-between">
            <h4 className="card-title mg-b-0">{`${t(
              "cilent_profile_export_tasks.task_list"
            )}`}</h4>
          </div>
        </div>
        <div className="card-body">
          <>
            <ul className="nav nav-tabs mb-3" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-selected="true"
                  tabIndex={-1}
                  onClick={() => setCompleteTab((prev: boolean) => !prev)}
                >
                  {t("global_v2.queue")}
                </a>
              </li>
              {(isAdmin || isCompanyAdmin || isManager) && (
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link"
                    data-bs-toggle="tab"
                    href="#product1"
                    role="tab"
                    aria-selected="false"
                    onClick={() => setCompleteTab((prev: boolean) => !prev)}
                  >
                    {t("global_v2.history")}
                  </a>
                </li>
              )}
            </ul>
            <div className="tab-content  text-muted">
              <div className="tab-pane active" id="home" role="tabpanel">
                {/* {list?.length === 0 ? (
                            <EmptyState />
                          ) : ( */}
                {workflowList?.length === 0 ? (
                  <EmptyState />
                ) : (
                  <>
                    {/* ovdje */}
                    <p className="mb-0">
                      <div className="table-responsive">
                        <Table className="align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th scope="col">{`${t("global.id")}`}</th>
                              <th scope="col">{`${t("workflow.name")}`}</th>
                              <th scope="col">{`${t("global.status")}`}</th>
                              <th scope="col">{`${t("global_v2.emails")}`}</th>
                              <th scope="col">{`${t(
                                "products.createdAt"
                              )}`}</th>
                              <th scope="col">{`${t("global.actions")}`}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {workflowList?.map((task) => {
                              return (
                                <tr key={task?.id}>
                                  <td>
                                    <Link to="#" className="fw-medium">
                                      #{task?.id}
                                    </Link>
                                  </td>
                                  <td>
                                    {
                                      task?.clientProfileExportData?.workflow
                                        ?.name
                                    }
                                  </td>
                                  <td>{`${t(
                                    `status_workflow.${task?.status?.toUpperCase()}`
                                  )}`}</td>
                                  <td
                                    className="p-0"
                                    style={{ lineHeight: "1.2" }}
                                  >
                                    {task?.clientProfileExportData
                                      ?.clientProfile?.client?.emails?.length >
                                    0 ? (
                                      <>
                                        <div>
                                          {task?.clientProfileExportData?.clientProfile?.client?.emails
                                            .slice(0, 2)
                                            .map(
                                              (
                                                email: string,
                                                index: number
                                              ) => (
                                                <div key={index}>{email}</div>
                                              )
                                            )}
                                        </div>
                                        {task?.clientProfileExportData
                                          ?.clientProfile?.client?.emails
                                          ?.length > 2 && (
                                          <>
                                            <a
                                              data-tooltip-id={`my-tooltip-data-html-${task?.id}`}
                                              data-tooltip-html={task?.clientProfileExportData?.clientProfile?.client?.emails
                                                .slice(
                                                  2,
                                                  task?.clientProfileExportData
                                                    ?.clientProfile?.client
                                                    ?.emails?.length
                                                )
                                                .map(
                                                  (email: string) =>
                                                    `<div>${email}</div>`
                                                )
                                                .join("")}
                                            >
                                              <span className="fw-bold">
                                                {t(
                                                  "cilent_profile_export_tasks.hover_for_more"
                                                )}
                                              </span>
                                            </a>
                                            <Tooltip
                                              id={`my-tooltip-data-html-${task?.id}`}
                                            />
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </td>
                                  <td>{formatDate(task?.createdAt)}</td>
                                  <td className="d-flex justify-content-center">
                                    <button
                                      onClick={() =>
                                        handleDownloadDocument(
                                          task?.filePath,
                                          task?.fileName
                                        )
                                      }
                                      className="btn btn-sm btn-secondary d-flex align-items-center"
                                      // disabled={!brand?.documents}
                                      disabled={!task?.filePath}
                                    >
                                      <i className="ri-file-download-fill me-1" />
                                      {t("global.document")}
                                    </button>
                                    <button
                                      disabled={task?.status === "sent"}
                                      onClick={() => handleSend(task?.id)}
                                      className="btn btn-sm btn-primary d-flex align-items-center mx-2"
                                    >
                                      {t("global_v2.send")}
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger d-flex align-items-center"
                                      onClick={() => {
                                        setSelectedClient({
                                          name: task?.clientProfileExportData
                                            ?.workflow?.name,
                                          id: task?.id,
                                        });
                                        handleShow();
                                      }}
                                    >
                                      <i className="ri-delete-bin-fill me-1" />
                                      {`${t("global.delete")}`}
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </p>
                    {completeTab && (
                      <div className="d-flex justify-content-end ">
                        {totalPages! <= 1 ? (
                          ""
                        ) : (
                          <Pagination
                            page={page!}
                            totalPages={totalPages!}
                            handlePagination={handlePages!}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="tab-pane " id="product1" role="tabpanel">
                {completedList?.length === 0 ? (
                  <EmptyState />
                ) : (
                  <>
                    <p className="mb-0">
                      <div className="table-responsive">
                        <Table className="align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th scope="col">{`${t("global.id")}`}</th>
                              <th scope="col">{`${t("workflow.name")}`}</th>
                              <th scope="col">{`${t("global.status")}`}</th>
                              <th scope="col">{`${t("global_v2.emails")}`}</th>
                              <th scope="col">{`${t(
                                "products.createdAt"
                              )}`}</th>
                              <th scope="col">{`${t("global_v2.sendAt")}`}</th>
                              {/* <th scope="col">{`${t("global.action")}`}</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {completedList?.map((task: any) => {
                              return (
                                <tr key={task?.id}>
                                  <td>
                                    <Link to="#" className="fw-medium">
                                      #{task?.id}
                                    </Link>
                                  </td>
                                  <td>
                                    {
                                      task?.clientProfileExportData?.workflow
                                        ?.name
                                    }
                                  </td>
                                  <td>{`${t(
                                    `status_workflow.${task?.status?.toUpperCase()}`
                                  )}`}</td>
                                  <td
                                    className="p-0"
                                    style={{ lineHeight: "1.2" }}
                                  >
                                    {task?.clientProfileExportData
                                      ?.clientProfile?.client?.emails?.length >
                                    0 ? (
                                      <>
                                        <div>
                                          {task?.clientProfileExportData?.clientProfile?.client?.emails
                                            .slice(0, 2)
                                            .map(
                                              (
                                                email: string,
                                                index: number
                                              ) => (
                                                <div key={index}>{email}</div>
                                              )
                                            )}
                                        </div>
                                        {task?.clientProfileExportData
                                          ?.clientProfile?.client?.emails
                                          ?.length > 2 && (
                                          <>
                                            <a
                                              data-tooltip-id={`my-tooltip-data-html-${task?.id}`}
                                              data-tooltip-html={task?.clientProfileExportData?.clientProfile?.client?.emails
                                                .slice(
                                                  2,
                                                  task?.clientProfileExportData
                                                    ?.clientProfile?.client
                                                    ?.emails?.length
                                                )
                                                .map(
                                                  (email: string) =>
                                                    `<div>${email}</div>`
                                                )
                                                .join("")}
                                            >
                                              <span className="fw-bold">
                                                {t(
                                                  "cilent_profile_export_tasks.hover_for_more"
                                                )}
                                              </span>
                                            </a>
                                            <Tooltip
                                              id={`my-tooltip-data-html-${task?.id}`}
                                            />
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <span>-</span>
                                    )}
                                  </td>
                                  <td>{formatDate(task?.createdAt)}</td>
                                  <td>
                                    {task?.sendAt
                                      ? formatDate(task?.sendAt)
                                      : "-"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </p>
                    {completeTab && (
                      <div className="d-flex justify-content-end ">
                        {totalPagesCompleted! <= 1 ? (
                          ""
                        ) : (
                          <Pagination
                            page={pageCompleted!}
                            totalPages={totalPagesCompleted!}
                            handlePagination={handlePagesCompleted!}
                          />
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
          {!completeTab && (
            <div className="d-flex justify-content-end ">
              {totalPages <= 1 ? (
                ""
              ) : (
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  handlePagination={handlePages}
                />
              )}
            </div>
          )}

          <ConfirmDelete
            show={show}
            setShow={setShow}
            itemName={selectedClient?.name}
            deleteHandler={deleteHandler}
            selectedProduct={selectedClient}
          />
        </div>
      </div>
    </>
  );
};
